import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _CloseRingDuotoneLine(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.424 8.576a.6.6 0 0 0-.848.848L11.15 12l-2.575 2.576a.6.6 0 0 0 .848.848L12 12.85l2.576 2.575a.6.6 0 0 0 .848-.848L12.848 12l2.576-2.576a.6.6 0 0 0-.848-.848L12 11.152z", clipRule: "evenodd" })));
}
const CloseRingDuotoneLine = forwardRef(_CloseRingDuotoneLine);
export { CloseRingDuotoneLine };
